import { PropertiesTableProps } from '../../../../shared/types'

export const WizardButtonsProperties: PropertiesTableProps = {
  '[Form.ButtonRow](/uilib/extensions/forms/Form/ButtonRow/properties/)': {
    doc: 'ButtonRow properties.',
    type: 'Various',
    status: 'optional',
  },
}
